import gql from 'graphql-tag';

export { CREATE_PERSON } from './createPerson';


const CONTACT_FRAGMENT = gql`
	fragment contact on Person {
		id
		name
		email
		phoneNumber
		role
		attachedClients {
			id
			name
		}
	}
`;

export const GET_CONTACTS = gql`
	query(
		$page: Int!,
		$perPage: Int!,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: PersonPageFilter
	) {
		getPersons(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...contact
			}
			count
		}
	}
	${CONTACT_FRAGMENT}
`;

export const GET_CONTACTS_SUBSCRIPTION = gql`
	subscription ($input: PersonSubscriptionInput!) {
		PersonSubscription(input: $input) {
			person {
				...contact
			}
			destroyedPersonId
		}
	}
	${CONTACT_FRAGMENT}
`;



export const GET_CONTACTS_COUNT = gql`
	query {
		countPersons
	}
`;
